import EffectsBlock from './EffectsBlock';

export default EffectsBlock;
